exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/absences/absences.component.css
// module id = ../../../../../src/app/dialogs/absences/absences.component.css
// module chunks = main